import {
  Button,
  makeStyles,
  Paper,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';
import { useHistory } from 'react-router-dom';
import { useAnswerContext } from '../../context';
import { Question } from './components';
import { flow1 } from './data';
const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: '90%',
    width: 900,
    marginBottom: 90,
    transition: 'all 0.4s ease-In',
    boxShadow: 'rgb(0 0 0 / 10%) 0px 2px 13px 0px',
    position: 'relative',
    borderRadius: 15,
    [theme.breakpoints.down('md')]: {
      marginTop: 40,
    },
    [theme.breakpoints.up('md')]: {
      marginTop: 140,
    },
  },
  line: {
    height: 10,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    transition: 'all 0.4s ease-In',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
  },
  number: {
    margin: '20px 50px 30px',
    fontSize: 16,
  },
  content: {
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      margin: '40px 30px 6px',
    },
    [theme.breakpoints.up('md')]: {
      margin: '64px 50px 6px',
    },
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    zIndex: 10,
    width: '100%',
  },
}));

const last = flow1.length - 1;

export const Survey = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const { setComplete, values } = useAnswerContext();
  const { paper, line, number, content, footer } = useStyles();
  const divRef = useRef<HTMLDivElement>(null);
  const step = sessionStorage.getItem('step');
  const [activeStep, setActiveStep] = useState(step ? +step : 0);
  const [maxHeight, setMaxHeight] = useState(900);
  const [minHeight, setMinHeight] = useState(394);
  const history = useHistory<any>();
  const questions = flow1;
  const [show, changeShowTo] = useState(true);

  useEffect(() => {
    if (activeStep === 0) {
      changeShowTo(true)
    }
  }, [activeStep])

  useEffect(() => {
    sessionStorage.setItem('step', activeStep.toString());
    if (history.location.state?.activeStep !== activeStep) {
      const search = history.location.search;
      history.push(
        history.location.pathname ? history.location.pathname + search : '/' + search,
        { activeStep },
      );
    }
  }, [activeStep, history]);

  useEffect(() => {
    const unlisten = history.listen((x: any) => {
      if (
        typeof x.state?.activeStep === 'number' &&
        activeStep !== x.state.activeStep
      ) {
        setActiveStep(x.state.activeStep);
      }
      if (x.state?.complete) {
        setComplete();
      }
    });
    return () => {
      unlisten();
    };
  }, [history, activeStep, setComplete]);

  useLayoutEffect(() => {
    if (!divRef?.current) {
      return;
    }
    const resizeObserver = new ResizeObserver((data) => {
      setMaxHeight(data[0].contentRect.height + 150);
      setMinHeight(data[0].contentRect.height + 150);
    });
    resizeObserver.observe(divRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  const data = questions[activeStep];

  const onNext = useCallback(() => {
    setActiveStep((x) => x + 1);
  }, []);
  const onBack = useCallback(() => {
    setActiveStep((x) => x - 1);
  }, []);

  useEffect(() => {
    if (activeStep) {
      divRef.current!.scrollIntoView();
    }
  }, [activeStep]);

  return (
    <>
      {show ? (
        <div
          style={{
            maxWidth: '90%',
            width: 900,
            display: 'flex',
            justifyContent: matches ? 'center' : 'flex-start',
            marginTop: 20,
          }}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              divRef.current!.scrollIntoView();
            }}
          >
            Start assessment
          </Button>
        </div>
      ) : null}
      <Paper className={paper} style={{ maxHeight, minHeight }}>
        <div ref={divRef}>
          <div className={content}>
            <Question
              onNewPage={() => divRef.current!.scrollIntoView()}
              onNext={onNext}
              onPrevious={onBack}
              isPreviousDisabled={activeStep === 0}
              changeShowTo={changeShowTo}
              {...data}
            />
          </div>
          <div className={footer}>
            <div className={number}>
              <strong>{activeStep + 1}</strong> of {questions.length}
            </div>
            <div
              className={line}
              style={{
                background: data.progressBg,
              }}
            ></div>
            <div
              className={line}
              style={{
                background: data.progressMain,
                width: `${(100 / questions.length) * (activeStep + 1)}%`,
                borderBottomRightRadius: activeStep === last ? 4 : 0,
              }}
            ></div>
          </div>
        </div>
      </Paper>
    </>
  );
};
